export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9373.163b9138.jpg";